import { geoConfig } from './geoConfig.js';
import { seoConfig } from './seoConfig.js';

export const LLMS_TXT_URL = `${geoConfig.siteUrl}${geoConfig.llmsTxtPath}`;

/** FAQPage schema for generative search / rich answers */
export function generateFAQSchema(faqItems) {
  if (!faqItems?.length) return null;

  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqItems.map(({ question, answer }) => ({
      '@type': 'Question',
      name: question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: answer,
      },
    })),
  };
}

/** WebSite + Organization graph for entity clarity in AI answers */
export function generateWebSiteSchema(options = {}) {
  const url = options.url || geoConfig.siteUrl;

  return {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'WebSite',
        '@id': `${url}/#website`,
        url,
        name: geoConfig.siteName,
        description: options.description || seoConfig.defaultDescription,
        publisher: { '@id': `${url}/#organization` },
        inLanguage: 'en',
      },
      {
        '@type': 'Organization',
        '@id': `${url}/#organization`,
        name: seoConfig.organization.name,
        url: seoConfig.organization.url,
        logo: seoConfig.organization.logo,
        description: seoConfig.organization.description,
        contactPoint: seoConfig.organization.contactPoint,
      },
    ],
  };
}

function asGraphNodes(node) {
  if (!node) return [];
  if (Array.isArray(node)) return node.flatMap(asGraphNodes);
  if (node['@graph']) return node['@graph'];
  const { '@context': _context, ...rest } = node;
  return [rest];
}

/** Merge primary structured data with optional GEO schemas (FAQ, WebSite, etc.) */
export function collectStructuredData(primary, geoSchemas = []) {
  const extras = (Array.isArray(geoSchemas) ? geoSchemas : [geoSchemas]).filter(Boolean);
  if (!primary && extras.length === 0) return null;
  if (!extras.length) return primary;

  return {
    '@context': 'https://schema.org',
    '@graph': [...asGraphNodes(primary), ...extras.flatMap(asGraphNodes)],
  };
}
